/* eslint-disable react/forbid-elements */
import * as React from 'react';
import { Responsive } from '@cian/ui-kit';

export const IconMail = () => (
  <>
    <Responsive desktop tablet>
      <svg width="14" height="10" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <path id="mail_icon" d="M14 9V.114H0V9z" />
        </defs>
        <g fill="none" fillRule="evenodd">
          <g transform="translate(0 1)">
            <mask id="mail_icon-mask" fill="#fff">
              <use xlinkHref="#mail_icon" />
            </mask>
            {/* tslint:disable-next-line:max-line-length */}
            <path
              d="M7.486 5.666a.745.745 0 0 1-.973 0L0 .114V8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V.114L7.486 5.666z"
              fill="currentColor"
              fillRule="nonzero"
              mask="url(#b)"
            />
          </g>
          <path fill="currentColor" fillRule="nonzero" d="M12.995 0H1.005L7 5.11z" />
        </g>
      </svg>
    </Responsive>
    <Responsive phone>
      <svg width="16" height="12" xmlns="http://www.w3.org/2000/svg">
        <g stroke="currentColor" strokeWidth="2" fill="none" fillRule="evenodd">
          <rect x="1" y="1" width="14" height="10" rx="2" />
          <path d="M2 3l4.89 3.26a2 2 0 0 0 2.22 0L14 3" />
        </g>
      </svg>
    </Responsive>
  </>
);
